import { render, staticRenderFns } from "./Work.vue?vue&type=template&id=1c5600b4&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"
import style0 from "./Work.vue?vue&type=style&index=0&id=1c5600b4&prod&scoped=true&lang=css"
import style1 from "./Work.vue?vue&type=style&index=1&id=1c5600b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5600b4",
  null
  
)

export default component.exports